import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Style from "../Styles/Common.module.css";
import Button from "../Styles/Button.module.css";
import LoginPopup from "../Common/Login/UserLogin";

const LifeMemberComponents = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [loginShow, setLoginShow] = useState(false);

  const loginShowHandler = ()=>{
    setLoginShow(true)
}
const loginCloseHandler = ()=>{
    setLoginShow(false)
   
}
//   useEffect(() => {
//     if (isAuthenticated) {
//       navigate("/membership");
//     }
//   }, [isAuthenticated, navigate]);

  return (
    <div className={`${Style.lifeMemberSec} ${Style.componentsSpace}`}>
      <Container>
        <Row className={Style.innerSpace}>
          <Col md={6}>
            <figure>
              <img src={require("../../assest/images/life-member-card.png")} alt="Life Member Card" loading="lazy"/>
            </figure>
          </Col>
          <Col md={6}>
            <div className={Style.memberDetail}>
              <div className={Style.sectionTitle}>
                <h2>Become a Life Member</h2>
              </div>
              <p>Become a life member of MAAD and be a privileged mayoite</p>
              {!isAuthenticated ? (
                <button type="button" onClick={loginShowHandler} className={Button.brownBorderBtn}>Know More</button>
              ) : (
                <Link to="/membership" className={Button.brownBorderBtn}>Know More</Link>
              )}
            </div>
          </Col>
        </Row>
      </Container>
      {loginShow && <LoginPopup onClose={loginCloseHandler} />}
    </div>
  );
};

export default LifeMemberComponents;
